module.exports = __webpack_public_path__ + "static/media/menu.d1519f17.svg";